import type {PropertyValuesRecord} from '@github-ui/custom-properties-types'
import {useMutation} from '@github-ui/react-query'
import sudo from '@github-ui/sudo'
import {reactFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  setValuesPath: string
  onSuccess: () => void
  onError: (message: string) => void
}
export function useSetPropertiesValuesMutation({setValuesPath, onSuccess, onError}: Props) {
  return useMutation({
    onMutate: async () => {
      if (!(await sudo())) throw new Error('Unauthorized')
    },
    mutationFn: async ({
      targetIds,
      changedProperties,
    }: {
      targetIds: number[]
      changedProperties: PropertyValuesRecord
    }) => {
      const response = await reactFetchJSON(setValuesPath, {
        method: 'POST',
        body: {
          targetIds,
          properties: changedProperties,
        },
      })

      if (response.ok) return

      let error: string | undefined
      try {
        const data = (await response.json()) as {error?: string}
        error = data.error
      } catch {
        // ignore JSON parse errors
      }
      throw new Error(error ?? 'Failed to update properties')
    },
    onSuccess,
    onError: error => {
      onError(error.message)
    },
  })
}
